// frontend/src/components/LazyAnimations.js
import React, { lazy, Suspense } from 'react';
import '../styles/animations.css';

// Ленивая загрузка компонентов с анимациями
const LazyMotionDiv = lazy(() => 
    import('framer-motion').then(module => ({
        default: module.motion.div
    }))
);

const LazyAnimatePresence = lazy(() =>
    import('framer-motion').then(module => ({
        default: module.AnimatePresence
    }))
);

// Fallback компонент для анимаций
const AnimationFallback = ({ children, className, style }) => (
    <div className={className} style={style}>
        {children}
    </div>
);

// Оптимизированный wrapper для motion.div
export const OptimizedMotionDiv = React.memo(({ 
    children, 
    initial, 
    animate, 
    exit, 
    transition,
    className,
    style,
    onClick,
    ...props 
}) => (
    <Suspense fallback={<AnimationFallback className={className} style={style}>{children}</AnimationFallback>}>
        <LazyMotionDiv
            initial={initial}
            animate={animate}
            exit={exit}
            transition={transition}
            className={className}
            style={style}
            onClick={onClick}
            {...props}
        >
            {children}
        </LazyMotionDiv>
    </Suspense>
));

// Оптимизированный wrapper для AnimatePresence
export const OptimizedAnimatePresence = React.memo(({ children, mode, ...props }) => (
    <Suspense fallback={<div>{children}</div>}>
        <LazyAnimatePresence mode={mode} {...props}>
            {children}
        </LazyAnimatePresence>
    </Suspense>
));

// Предустановленные анимации
export const fadeInOut = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
    transition: { duration: 0.3 }
};

export const slideInOut = {
    initial: { x: -300, opacity: 0 },
    animate: { x: 0, opacity: 1 },
    exit: { x: 300, opacity: 0 },
    transition: { type: "spring", stiffness: 300, damping: 30 }
};

export const scaleInOut = {
    initial: { scale: 0.8, opacity: 0 },
    animate: { scale: 1, opacity: 1 },
    exit: { scale: 0.8, opacity: 0 },
    transition: { duration: 0.2 }
};

export const modalAnimation = {
    initial: { scale: 0.9, opacity: 0 },
    animate: { scale: 1, opacity: 1 },
    exit: { scale: 0.9, opacity: 0 },
    transition: { type: "spring", stiffness: 300, damping: 30, duration: 0.2 }
};

// Хук для предзагрузки анимаций
export const usePreloadAnimations = () => {
    React.useEffect(() => {
        // Предзагружаем Framer Motion при первой возможности
        const preloadTimer = setTimeout(() => {
            import('framer-motion');
        }, 2000);

        return () => clearTimeout(preloadTimer);
    }, []);
};
